module.exports = __webpack_public_path__ + "img/PILLAR3Religion_BIO.d3a81e5e.jpg";